import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getByKrsId = createAsyncThunk("mahasiswaKrs/getByKrsId", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/map/mhs/krs/detail/${id}`);
    return response.data;
});

export const getByNim = createAsyncThunk("mahasiswaKrs/getByNim", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/map/mhs/krs/detail/mhs/${id}`);
    return response.data;
});

export const getDataKrsMahasiswaFromDosen = createAsyncThunk("mahasiswaKrs/getDataKrsMahasiswaFromDosen", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/view/master/krs/mhs/check_krs`,val);
    return response.data;
});

export const approvalDosen = createAsyncThunk("mahasiswaKrs/approvalDosen", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/view/master/krs/mhs/approval_krs_dosen`,val);
    return response.data;
});

const initialState = {
    detailKrsId:[],
    listKrsMhs:[],
    detailNim:[],
    responseApproval:{},
    loading:false
}

const mahasiswaKrsSlice = createSlice({
    name:"mahasiswaKrs",
    initialState: initialState,
    reducers: {

    },
    extraReducers: (builder) => {
    builder
        .addCase(getByKrsId.pending, (state) => {
            state.loading = true;
        })
        .addCase(getByKrsId.fulfilled, (state, action) => {
            state.detailKrsId = action.payload
            state.loading = false;
        })
        .addCase(getByKrsId.rejected, (state, action) => {
            state.detailKrsId = false;
            console.error("Error:", action.error);
        })
    builder
        .addCase(approvalDosen.pending, (state) => {
            state.loading = true;
        })
        .addCase(approvalDosen.fulfilled, (state, action) => {
            state.responseApproval = action.payload
            state.loading = false;
        })
        .addCase(approvalDosen.rejected, (state, action) => {
            state.detailKrsId = false;
            console.error("Error:", action.error);
        })
    builder
        .addCase(getDataKrsMahasiswaFromDosen.pending, (state) => {
            state.loading = true;
        })
        .addCase(getDataKrsMahasiswaFromDosen.fulfilled, (state, action) => {
            state.listKrsMhs = action.payload
            state.loading = false;
        })
        .addCase(getDataKrsMahasiswaFromDosen.rejected, (state, action) => {
            state.detailKrsId = false;
            console.error("Error:", action.error);
        })
    builder
        .addCase(getByNim.pending, (state) => {
            state.loading = true;
        })
        .addCase(getByNim.fulfilled, (state, action) => {
            state.detailNim = action.payload
            state.loading = false;
        })
        .addCase(getByNim.rejected, (state, action) => {
            state.loading = false;
            console.error("Error:", action.error);
        })
    }
})

export const mahasiswaKrsSelector = (state) => state.mahasiswaKrs;
export default mahasiswaKrsSlice.reducer;